<template>
  <div class="client-preference-results">
    <ClientPreferenceResults
      :screen-sets="screenSetsWithMetricInfo"
      :assigned-colors="assignedColors"
      :entity="entity"
      :features="features"
    />
  </div>
</template>


<script>
import ClientPreferenceResults from './ClientPreferenceResults.vue';
import { getScreenSets, getMetrics } from '@frontend/api/api.js';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

export default {
  name: 'ClientPreferenceResultsView',
  components: { ClientPreferenceResults },
  props: {
    advisor: {
      type: Object,
      required: false,
      default: null,
    },
    features: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      screenSets: [],
      metrics: [],
      personID: null,
      entity: null,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useAdvisorStore),
    metricsHash() {
      const hash = {};

      this.metrics.forEach(metric => {
        hash[metric.id] = metric;
      });
      return hash;
    },
    namedScreenSets() {
      return this.screenSets.filter(screenSet => screenSet.issue_name);
    },
    wizardScreenSets() {
      return this.advisor?.firm.preferences.wizard_screen_sets;
    },
    screenSetsWithEntityMetrics() {
      let sets;
      if (this.wizardScreenSets?.length > 0) {
        sets = this.wizardScreenSets;
      } else {
        sets = this.namedScreenSets;
      }

      // Return all screensets but filter metrics so only those found in entityMetricHash are included
      return sets.map(screenSet => {
        const metrics = screenSet.metrics.filter(metric => {
          return this.entityMetricHash[metric.metric_description];
        });
        return { ...screenSet, metrics };
      });
    },
    filteredScreenSets() {
      // Filter screensets so only those with at least one metric are included
      return this.screenSetsWithEntityMetrics.filter(screenSet => {
        return screenSet.metrics.length > 0;
      });
    },
    screenSetsWithMetricInfo() {
      if (!this.filteredScreenSets) return [];
      return this.filteredScreenSets.map(screenSet => {
        const metrics = screenSet.metrics.map(metric => {
          const info = this.metricsHash[metric.metric_description];
          return { ...metric, info };
        });
        return { ...screenSet, metrics };
      });
    },
    entityScreenSetID() {
      return this.entity?.screen_sets[0].id;
    },
    entityScreenSet() {
      return this.screenSets?.find(set => {
        return set.id === this.entityScreenSetID;
      });
    },
    entityMetricHash() {
      const hash = {};

      this.entityScreenSet?.metrics.forEach(metric => {
        hash[metric.metric_description] = metric;
      });
      return hash;
    },
    colors() {
      return this.$root.$data.COLORS.assorted;
    },
    assignedColors() {
      const assigned = {};
      if (!this.screenSetsWithMetricInfo) return {};

      this.screenSetsWithMetricInfo.forEach((set, i) => {
        const n = i % this.colors.length;
        assigned[set.issue_name] = this.colors[n];
      });
      return assigned;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    personID() {
      this.getEntity();
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.setScreenSets();
    this.setMetrics();
    this.getPersonID();
  },
  updated() {},
  methods: {
    async setScreenSets() {
      const res = await getScreenSets();
      this.screenSets = res.data.screen_sets;
    },
    async setMetrics() {
      const res = await getMetrics();
      this.metrics = res.data.metrics;
    },
    getPersonID() {
      const url = new URL(window.location.href);
      this.personID = url.searchParams.get('prospect');
    },
    async getEntity() {
      if (!this.personID) return null;
      const res = await fetch(`/api/v1/entities/${this.personID}/`);
      const data = await res.json();
      this.entity = data;
    },
  },
};
</script>


<style scoped>

</style>
